import { bootstrap as messagingReactBootstrap } from "@lookiero/messaging-react";
import { REMOVE_UI_SETTING } from "../../domain/uiSetting/command/removeUiSetting";
import { UPDATE_UI_SETTING } from "../../domain/uiSetting/command/updateUiSetting";
import { removeUiSettingHandler, updateUiSettingHandler } from "../../domain/uiSetting/model/uiSetting";
import { VIEW_UI_SETTING_BY_KEY, viewUiSettingByKeyHandler } from "../../projection/uiSetting/viewUiSettingByKey";
import { getUiSetting, saveUiSetting } from "../domain/uiSetting/model/storageUiSettings";
import { storageUiSettingByKeyView } from "../projection/uiSetting/model/storageUiSettingByKeyView";
const UI_SETTINGS_MESSAGING_CONTEXT_ID = "ui_settings";
const bootstrap = ({ storage }) => messagingReactBootstrap({ id: UI_SETTINGS_MESSAGING_CONTEXT_ID })
    .query(VIEW_UI_SETTING_BY_KEY, viewUiSettingByKeyHandler, {
    view: storageUiSettingByKeyView({ storage }),
})
    .command(UPDATE_UI_SETTING, updateUiSettingHandler)(getUiSetting, saveUiSetting, { storage })
    .command(REMOVE_UI_SETTING, removeUiSettingHandler)(getUiSetting, saveUiSetting, { storage })
    .build();
const bootstrapWithBuilder = ({ storage, messaging }) => messaging
    .query(VIEW_UI_SETTING_BY_KEY, viewUiSettingByKeyHandler, {
    view: storageUiSettingByKeyView({ storage }),
})
    .command(UPDATE_UI_SETTING, updateUiSettingHandler)(getUiSetting, saveUiSetting, { storage })
    .command(REMOVE_UI_SETTING, removeUiSettingHandler)(getUiSetting, saveUiSetting, { storage });
export { UI_SETTINGS_MESSAGING_CONTEXT_ID, bootstrap, bootstrapWithBuilder };
